var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var PostController = {
    /*****************************************************************************************************
        * Is using route "api/post/{id}/children/compare" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {PostWithChildrenCompareResult[]}
    ******************************************************************************************************/
    CheckChangedChildren: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/children/compare", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{id}/children" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @param {PostWithChildrenCompareResult[]} toUpdate
        * @returns {PostWithChildrenCompareResult[]}
    ******************************************************************************************************/
    DeleteChildren: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/children", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.toUpdate
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{id}/children/{visible}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} visible
        * @param {PostWithChildrenCompareResult[]} toUpdate
        * @returns {PostWithChildrenCompareResult[]}
    ******************************************************************************************************/
    ChangeVisible: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/children/{visible}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.toUpdate
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    Get: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}/{fromdate}/{todate}/{onlyvisible}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} fromdate
        * @param {string} todate
        * @param {PostVisibleState} onlyvisible
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetFromTo: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}/{fromdate}/{todate}/{onlyvisible}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/filtered" and http method "POST" to call the back-end.
    Returns posts that are filtered with a given filter.
    
        * @param {PostFilterDto} filter  filters the posts by several properties
        * @returns {PostDownloadDto[]}
    ******************************************************************************************************/
    GetFiltered: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/filtered", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/count/filtered" and http method "POST" to call the back-end.
    Counts filtered posts
    
        * @param {PostFilterDto} filter  filters the posts by several properties
        * @returns {number}
    ******************************************************************************************************/
    CountFiltered: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/count/filtered", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}/{type}/{onlyvisible?}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} type
        * @param {PostVisibleState} onlyvisible
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetByType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}/{type}/{onlyvisible?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/token/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetPaged: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/token/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/allgroups/sortby/{by}/{additionalData}" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @param {string} by
        * @param {string} additionalData
        * @param {number | null} loadingCount
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetPagedForAllGroupsSortedBy: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        if (data.loadingCount !== undefined)
            fd.append("loadingCount", JSON.stringify(data.loadingCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/allgroups/sortby/{by}/{additionalData}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/allgroups/trending" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @param {number | null} loadingCount
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetPagedForAllGroupsTrending: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        if (data.loadingCount !== undefined)
            fd.append("loadingCount", JSON.stringify(data.loadingCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/allgroups/trending", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/allgroups/trending/cursor" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @param {number | null} loadingCount
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetPagedForAllGroupsTrendingWithDbCursor: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        if (data.loadingCount !== undefined)
            fd.append("loadingCount", JSON.stringify(data.loadingCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/allgroups/trending/cursor", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/allgroups" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @param {number | null} loadingCount
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetPagedForAllGroups: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        if (data.loadingCount !== undefined)
            fd.append("loadingCount", JSON.stringify(data.loadingCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/allgroups", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/allgroups/cursor" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @param {number | null} loadingCount
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetPagedForAllGroupsWithDbCursor: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        if (data.loadingCount !== undefined)
            fd.append("loadingCount", JSON.stringify(data.loadingCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/allgroups/cursor", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/topN/{postType}/{n}" and http method "POST" to call the back-end.
    
        * @param {string} postType
        * @param {number} n
        * @returns {PostDownloadDto[]}
    ******************************************************************************************************/
    GetTopNPosts: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/topN/{postType}/{n}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/countallgroups" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @returns {number}
    ******************************************************************************************************/
    GetCountForAllGroups: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/countallgroups", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{id}/inherit/{force?}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} force
        * @returns {void}
    ******************************************************************************************************/
    InheritPost: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/inherit/{force?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/hide/{id}/{hidden}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} hidden
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    SetPostHidden: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/hide/{id}/{hidden}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/token/{groupid}/{type}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {string} type
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetTypedPaged: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/token/{groupid}/{type}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{id}/type" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {string}
    ******************************************************************************************************/
    GetElementType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/type", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{id}/single" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    GetSinglePost: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/single", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{id}/single/published/from/cms" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    GetSinglePostFromCMS: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/single/published/from/cms", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{id}/single/{context}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @param {string} context
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    GetSinglePostWithContext: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/single/{context}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{id}/single/{playlistId}/forPlaylist" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @param {string} playlistId
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    GetSinglePostForPlaylist: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/single/{playlistId}/forPlaylist", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{userid}/user" and http method "GET" to call the back-end.
    
        * @param {string} userid
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetForUser: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{userid}/user", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{userid}/user" and http method "POST" to call the back-end.
    Returns all posts for a given user as a paged result
    
        * @param {string} userid  the user
        * @param {TokenContainer} token  input continuation token for paged result
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    GetForUserPaged: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{userid}/user", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/createReference/{id}/{targetGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} targetGroupId
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    CreateReferenceChild: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/createReference/{id}/{targetGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{postid}" and http method "DELETE" to call the back-end.
    
        * @param {string} postid
        * @returns {void}
    ******************************************************************************************************/
    DeletePost: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{postid}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/export_dto_to_swagger" and http method "GET" to call the back-end.
    
        * @returns {MediaUploadDto}
    ******************************************************************************************************/
    ExportDto: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/export_dto_to_swagger", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}/tags" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {TagDownloadDto[]}
    ******************************************************************************************************/
    GetTags: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}/tags", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{postid}/copy/{groupid}/{typeName}" and http method "POST" to call the back-end.
    
        * @param {string} postid
        * @param {string} groupid
        * @param {string} typeName
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    CopyPost: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{postid}/copy/{groupid}/{typeName}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{postid}/promote" and http method "POST" to call the back-end.
    
        * @param {string} postid
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PromotePost: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{postid}/promote", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{postid}/demote" and http method "POST" to call the back-end.
    
        * @param {string} postid
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    DemotePost: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{postid}/demote", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/getRouteInfo/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {RouteInfoDto}
    ******************************************************************************************************/
    GetRouteInfo: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/getRouteInfo/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/lock/{id}/{connectionId}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} connectionId
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostLock: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/lock/{id}/{connectionId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/unlock/{id}/{connectionId}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} connectionId
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostUnlock: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/unlock/{id}/{connectionId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/unlockall/{connectionId}" and http method "POST" to call the back-end.
    
        * @param {string} connectionId
        * @returns {PostDownloadDto[]}
    ******************************************************************************************************/
    PostUnlockAll: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/unlockall/{connectionId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/{id}/children" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ExtendedDataCollection<PostChildren, PostDownloadDto>}
    ******************************************************************************************************/
    GetPostChildren: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/children", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/search" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} type
        * @param {string} lng
        * @param {string[]} groupIds
        * @returns {PostDownloadDto[]}
    ******************************************************************************************************/
    SearchPostText: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.groupIds !== undefined)
            fd.append("groupIds", JSON.stringify(data.groupIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/suggest" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {string} type
        * @param {string} lng
        * @param {string[]} groupIds
        * @returns {string[]}
    ******************************************************************************************************/
    SuggestPostTerm: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.groupIds !== undefined)
            fd.append("groupIds", JSON.stringify(data.groupIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/suggest", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/search1" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    SearchPostText1: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search1", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/search2" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    SearchPostText2: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search2", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/search3" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @param {TokenContainer} token
        * @param {number | null} loadingCount
        * @returns {SearchResultsDto<PostDownloadDto>}
    ******************************************************************************************************/
    SearchPostText3: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        if (data.loadingCount !== undefined)
            fd.append("loadingCount", JSON.stringify(data.loadingCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search3", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/search3/cursor" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @param {TokenContainer} token
        * @param {number | null} loadingCount
        * @returns {SearchResultsDto<PostDownloadDto>}
    ******************************************************************************************************/
    SearchPostText3WithDbCursor: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        if (data.loadingCount !== undefined)
            fd.append("loadingCount", JSON.stringify(data.loadingCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search3/cursor", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/search/systems" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {SearchSystems} systems
        * @param {string} progressId
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    SearchSystemsPostText: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        fd.append("systems", JSON.stringify(data.systems));
        fd.append("progressId", JSON.stringify(data.progressId));
        fd.append("lng", JSON.stringify(data.lng));
        fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search/systems", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/search/systems/post/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ExtendedDataCollection<ItemSearchResult<PostDownloadDto>, string>}
    ******************************************************************************************************/
    GetPostSystemsSearchResults: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search/systems/post/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/search/systems/wiki/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ExtendedDataCollection<WikiSearchResultDto, string>}
    ******************************************************************************************************/
    GetWikiSystemsSearchResults: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search/systems/wiki/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/Suggest2" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {string} type
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {string[]}
    ******************************************************************************************************/
    SuggestPostTerm2: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/Suggest2", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/Suggest1" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {string} type
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {string[]}
    ******************************************************************************************************/
    SuggestPostTerm1: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/Suggest1", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/suggest/system" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {SearchSystems} systems
        * @param {string} type
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {string[]}
    ******************************************************************************************************/
    SuggestSystemTerm: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        fd.append("systems", JSON.stringify(data.systems));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/suggest/system", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/link" and http method "POST" to call the back-end.
    
        * @param {LinkDefinitionUploadDto} linkDefinition
        * @returns {LinkDefinitionDownloadDto}
    ******************************************************************************************************/
    CreateAccessLink: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("linkDefinition", JSON.stringify(data.linkDefinition));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/link/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {LinkDefinitionDownloadDto[]}
    ******************************************************************************************************/
    GetAccessLink: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/link/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteAccessLink: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/link/public/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    AccessPublicLink: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link/public/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/link/private/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    AccessPrivateLink: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link/private/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/thumbCreated" and http method "POST" to call the back-end.
    
        * @param {CreateThumbnailQueueEntry} entry
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    ThumbCreated: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/thumbCreated", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.entry
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostController.js.map